import Route from '@ember/routing/route'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'
import type RolloverStudentImportService from 'teacher-ui-client/services/rollover-student-import'

export default class RolloverStudentsIndexRoute extends Route {
  @service router!: RouterService

  @service rolloverStudentImport!: RolloverStudentImportService

  get importJob() {
    return this.rolloverStudentImport.importJob
  }

  beforeModel() {
    // Redirect the user to the correct import step, if they previously started an import

    const { rolloverStudentImport, importJob } = this

    if (importJob?.file) {
      // there's a recent job
      if (rolloverStudentImport.validateCsv.isRunning) {
        // validation is currently running
        void this.router.transitionTo('manage.rollover.steps.students.import.validate')
      } else if (rolloverStudentImport.importCsv.isRunning) {
        // import is currently running
        void this.router.transitionTo('manage.rollover.steps.students.import.importing')
      } else if (importJob.valid === true && importJob.imported === undefined) {
        // job is validated, not yet imported, but no tasks running. must be at the confirm import step
        void this.router.transitionTo('manage.rollover.steps.students.import.confirm')
      }
    }
  }
}
